module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWAAAABACAYAAAAkuq3OAAAABmJLR0QA/wD/AP+gvaeTAAAAyElEQVR4nO3UUQmAABQEwadZ7aFF7GoFQWVBZgLc/e0MAAAAAAAAAAAAAAAAAAAAAAAAAAAA8LUl+DxmZg9+AZ7YZuZ8c3B9cwyA+wQYICLAABEBBogIMEBEgAEiAgwQEWCAiAADRAQYICLAABEBBogIMEBEgAEiAgwQEWCAiAADRAQYICLAABEBBogIMEBEgAEiAgwQEWCAiAADRAQYICLAABEBBogIMEBEgAEiAgwAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/NYF5D0CQKw7XOIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/minus/PNG-minus-black.png
// module id = 92
// module chunks = 0